import { CreateGroupBody } from 'types/GlobalGroup'
import { TSignedInAccount } from 'types/GlobalAccount'

export const getDefaultCreateGroupBody = (
  account: TSignedInAccount | null
): CreateGroupBody => {
  return {
    profile_color: 'primary',
    show_on_home: true,
    is_private: false,
    owners: account ? [account.id] : [],
    name: ''
  }
}
